export const DOCTOR_ACCENT_COLORS = [
    '#6366f1',
    '#14b8a6',
    '#f97316',
    '#a855f7',
    '#ec4899',
    '#0ea5e9',
    '#84cc16',
    '#e11d48',
];

export function userIsDoctor(user) {
    const roles = user?.roles;
    if (Array.isArray(roles)) {
        return roles.some((role) => {
            if (typeof role === 'string') return role === 'doctor';
            if (role && typeof role === 'object') {
                const name = role.name ?? role.slug ?? role.value ?? role.label;
                return name === 'doctor';
            }
            return false;
        });
    }
    if (typeof roles === 'string') {
        return roles.split(/[,\s]+/).map((r) => r.trim()).includes('doctor');
    }
    return user?.role === 'doctor';
}

export function pickDoctorsFromUsers(users) {
    return (users ?? [])
        .filter(userIsDoctor)
        .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '', 'uz'));
}

export function mapApiCalendarEvent(event) {
    return {
        id: event.id,
        title: event.title,
        phone: event.phone,
        date: event.start_at,
        description: event.description,
        patient_id: event.patient_id ?? event.patient?.id ?? null,
        doctor_id: event.doctor_id ?? event.doctor?.id ?? null,
        doctor: event.doctor ?? null,
        type: event.type,
        service: event.service,
    };
}

export function getInitials(name) {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

export function getDoctorColor(doctorId, colorMap) {
    if (doctorId == null) return '#94a3b8';
    return colorMap.get(doctorId) ?? '#6366f1';
}

export function buildDoctorColorMap(doctors) {
    const map = new Map();
    doctors.forEach((d, i) => {
        map.set(d.id, DOCTOR_ACCENT_COLORS[i % DOCTOR_ACCENT_COLORS.length]);
    });
    return map;
}

export function buildCalendarPayload({
    eventTitle,
    eventNumber,
    formattedDate,
    eventDescription,
    selectedPatientId,
    selectedDoctorId,
}) {
    return {
        title: eventTitle,
        phone: eventNumber,
        start_at: formattedDate,
        start_time: null,
        end_at: null,
        end_time: null,
        description: eventDescription?.trim() ? eventDescription : null,
        doctor_id: selectedDoctorId ?? null,
        ...(selectedPatientId ? { patient_id: selectedPatientId } : {}),
    };
}
